/**
 * Internal link route name constants
 */

export const AUTH_WELCOME_PAGE = 'WelcomePage'
export const LOGIN_PAGE = 'LoginPage'
export const SIGNUP_PAGE = 'SignupPage'
export const RESET_PASSWORD_PAGE = 'ResetPasswordPage'
export const COMPONENTS_LIBRARY_PAGE = 'ComponentsLibraryPage'

export const PROFILE_PAGE = 'ProfilePage'
export const SHARE_PROFILE_PAGE = 'ShareProfilePage'
export const SHARE_GROUP_PAGE = 'ShareUpspacePage'
export const ACCOUNT_PAGE = 'AccountPage'
export const TRAINERS_PAGE = 'TrainersPage'
export const WORKOUTS_PAGE = 'WorkoutsPage'
export const BOARD_PAGE = 'BoardPage'
export const LEADERBOARD_PAGE = 'LeaderboardPage'
export const GROUP_PAGE = 'UpspacePage'
export const PROGRAM_PAGE = 'ProgramPage'
export const EDIT_PROGRAM_PAGE = 'EditProgramPage'
export const ACTIONS_LIST_PAGE = 'ActionsListPage'
export const UPSPACE_SETTINGS_PAGE = 'UpspaceSettingsPage'
export const FOLLOWERS_MEMBERS_PAGE = 'FollowersMembersPage'
export const FOLLOWERS_FRIENDS_PAGE = 'FollowersFriendsPage'
export const MEMBER_PROFILE_PAGE = 'MemberProfilePage'
export const MEMBERSHIPS_PAGE = 'MembershipsPage'
export const EDIT_PROFILE_PAGE = 'EditProfilePage'
export const ONBOARDING_USER_TYPE_PAGE = 'OnboardingUserTypePage'
export const ONBOARDING_EDIT_PROFILE_PAGE = 'OnboardingEditProfilePage'
export const EDIT_WORKOUT_PAGE = 'EditWorkoutPage'
export const CREATE_WORKOUT_PAGE = 'CreateWorkoutPage'
export const CREATE_POST_PAGE = 'CreatePostPage'
export const POST_PAGE = 'PostPage'
export const FEED_PAGE = 'FeedPage'
export const NOTIFICATIONS_PAGE = 'NotificationsPage'
export const EXPLORE_PAGE = 'ExplorePage'
export const NOTIFICATION_SETTINGS_PAGE = 'NotificationsSettingsPage'
export const UPSCORE_PAGE = 'UpscorePage'

export const CURRENT_USER_GROUP_PAGE = 'CurrentUserUpspacePage'
export const GROUP_SETTINGS_PAGE = 'GroupSettingsPage'
export const CURRENT_TRAINER_GROUP_PAGE = 'CurrentTrainerUpspacePage'
export const CHAT_PAGE = 'ChatPage'
export const COMMENT_PAGE = 'CommentPage'
export const CHAT_ROOM = 'ChatRoom'

// Coach Onboarding Stack
export const FLOW_SELECION_PAGE = 'FlowSelectionPage'
export const PROGRAM_QUESTIONS_PAGE = 'ProgramQuestionsPage'
export const PROGRAM_DESCRIPTION_PAGE = 'ProgramDescriptionPage'
export const PROGRAM_NAME_PAGE = 'ProgramNamePage'
export const PROGRAM_IMAGE_PAGE = 'ProgramImagePage'
export const UPSPACE_NAME_PAGE = 'UpspaceNamePage'
export const UPSPACE_DESCRIPTION_PAGE = 'UpspaceDescriptionPage'
export const UPSPACE_IMAGE_PAGE = 'UpspaceImagePage'
export const UPSPACE_NEXT_PAGE = 'UpspaceNextPage'

// Create Post Stack
export const POST_TYPE_SELECTION_PAGE = 'PostTypeSelectionPage'
export const ACTION_TYPE_SELECTION_PAGE = 'ActionSelectionPage'
export const ACTIVITY_GROUP_SELECTION_PAGE = 'ActivityGroupSelectionPage'
export const ACTIVITY_TYPE_SELECTION_PAGE = 'ActivityTypeSelectionPage'
export const ACTIVITY_DETAILS_PAGE = 'ActivityDetailsPage'

// Navigators
export const MAIN_TABS = 'MainTabs'
export const CLIENT_STACK = 'ClientStack'
export const ONBOARDING_STACK = 'OnboardingStack'
export const COACH_ONBOARDING_STACK = 'CoachOnboardingStack'
export const HOME_STACK = 'HomeStack'
export const NOTIFICATIONS_STACK = 'NotificationsStack'
export const GROUP_STACK = 'GroupStack'
export const BOARD_STACK = 'BoardStack'
export const PROFILE_STACK = 'ProfileStack'
export const PROFILE_GROUP_STACK = 'ProfileGroupStack'
export const TRAINER_MAIN_TABS = 'TrainerMainTabs'
export const CHAT_STACK = 'ChatStack'
